import { memo, useState } from 'react';
import { useCooperativeId } from 'hooks';
import { Document } from 'models';
import { saveAs } from 'file-saver';
import services from 'services';

import { Loader } from 'components';
import AttachFileIcon from '@material-ui/icons/AttachFile';

import { useStyles } from './style';

interface Props {
  document: Document;
  withIcon?: boolean;
}

const DownloadDocument: React.FC<Props> = ({ document, withIcon = false }) => {
  const classes = useStyles();
  const coopId = useCooperativeId();
  const [loading, setLoading] = useState(false);

  const download = async (name: string) => {
    try {
      setLoading(true);

      const { data } = await services.get(
        `/api/user/cooperatives/${coopId}/documents/account/${coopId}/download?fileUrl=${document.Id}`,
        {
          responseType: 'blob',
          headers: {
            Accept: '*/*',
          },
        }
      );

      saveAs(data, name);
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };

  return (
    <div className={classes.root}>
      {loading ? (
        <div className={classes.mr15}>
          <Loader size={15} themeColor="darkBlue" />
        </div>
      ) : null}
      {withIcon ? <AttachFileIcon className={classes.attachIcon} /> : null}
      <span className={classes.name} onClick={() => download(document.Name)}>
        {document.Name}
      </span>
    </div>
  );
};

export default memo(DownloadDocument);
